import React from 'react';
import { withRouter } from "react-router";
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SideBarList from './SideBarList';
import SideBarListItem from './SideBarListItem';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`
const Header = styled.h2`
  border-bottom: 1px solid #333;
  padding-bottom: 10px;
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 10px 20px;
`
const SideBarListStyled = styled(SideBarList)`
`
const SideBarListItemStyled = styled(SideBarListItem)`
  width: 185px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-right: 1px solid #ccc;
`

class SideBarNav extends React.Component {
  getTabs = () => {
    return this.props.navComponents.map((tab, index) => (
      <SideBarListItemStyled key={`side-bar-tab-${index}`} label={tab.label} {...tab.props}/>
    ))
  }

  getComponent = index => {
    const navComponent = this.props.navComponents[index].component;
    const navHeader = this.props.navComponents[index].header;
    return { navComponent, navHeader };
  }

  getTabIndex = () => {
    const { navComponents, location } = this.props;
    const path = location.pathname;

    for(let i = 0; i < navComponents.length; i++) {
      const compPath = navComponents[i].path;
      if(path.includes(compPath)){
        return i;
      }
    }
    
    return 0;
  }

  render() {
    const index = this.getTabIndex();
    const { navComponent, navHeader } = this.getComponent(index);

    return (
      <Container>
        <Wrapper>
          <SideBarListStyled value={index} onChange={this.handleChange}>
            {this.getTabs()}
          </SideBarListStyled>
          {/* {this.getSideContent()} */}
        </Wrapper>
        <Content>
          {
            navHeader &&
            <Header>{navHeader}</Header>
          }
          {navComponent}
        </Content>
      </Container>
    );
  }
}

SideBarNav.propTypes = {
  sideComponent: PropTypes.object,
};

SideBarNav.defaultProps = {
  sideComponent: null,
};

export default withRouter(SideBarNav);
